module.exports = __webpack_public_path__ + "media/home_video.fe04597e.mp4";